/**
 * Route for `apptrove-pricing`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ApptrovePricingPage } from "../features/apptrove-pricing/ApptrovePricingPage";

export const apptrovePricingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/apptrove-pricing",
	component: ApptrovePricingPage,
});

export default apptrovePricingRoute;
